import type { ReactElement } from "react";
import React, { useEffect, useMemo, useState } from "react";
import { useRouter, useTranslation } from "@edreamsodigeo/frontend-core";
import { Box, Flex, Popover } from "@edreamsodigeo/prisma-design-system";

import useUserAccount from "~/clientState/hooks/useUserAccount";
import {
  getTrackingCategoryName,
  PAGE_TRACKING,
} from "~/tools/getTrackingCategoryName";
import PrimeHooverBannerContainer from "../PrimeHooverBanner";
import HeaderPrimeButton from "./HeaderPrimeButton";
import { useIsPrimeMarket } from "~/clientState/hooks/usePrimeSitePropertiesQuery";

const isPrimePage = (category: string): boolean => {
  return (
    category === PAGE_TRACKING.HOME ||
    category === PAGE_TRACKING.DYNPACK_TAB ||
    category === PAGE_TRACKING.FLIGHT_TAB ||
    category === PAGE_TRACKING.HOTELS_TAB
  );
};

const isHomePage = (category: string): boolean => {
  return category === PAGE_TRACKING.HOME;
};

const HeaderPrimeButtonContainer = (): ReactElement => {
  const { t } = useTranslation();
  const { pathname } = useRouter();
  const { data, loading, errors } = useUserAccount();
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const [alignPopover, setAlignPopover] = useState<
    "start" | "end" | "middle" | "none"
  >("start");

  const flightsUrl = t("visibility.user.menu.most.prime.flights");
  const hotelsUrl = t("visibility.user.menu.most.prime.hotels");
  const dynpackUrl = t("visibility.flighthotel.url");
  let trackingCategory = "";

  if (flightsUrl && hotelsUrl && dynpackUrl) {
    trackingCategory = getTrackingCategoryName(
      flightsUrl,
      hotelsUrl,
      dynpackUrl,
      pathname,
    );
  }

  const isPrimeMarket = useIsPrimeMarket();

  useEffect(() => {
    if (trackingCategory) {
      setAlignPopover(isPrimePage(trackingCategory) ? "start" : "end");
    }
  }, [trackingCategory]);

  const [userLoggedInfo, setUserLoggedInfo] = useState<boolean | undefined>(
    undefined,
  );

  useMemo(() => {
    if (!loading && !errors) {
      setUserLoggedInfo(data?.userAccount?.userMembership.isActive || false);
    }
  }, [data, loading, errors]);

  return isPrimeMarket ? (
    <Box
      onMouseLeave={(): void => {
        setShowBanner(false);
      }}
    >
      <HeaderPrimeButton
        pageCategoryName={trackingCategory}
        hoverButton={(): void => setShowBanner(true)}
        isPrimeLoggedUser={userLoggedInfo}
        fullWidth={false}
      />
      <Flex position={"relative"} sx={{ zIndex: 400 }}>
        <Popover
          open={showBanner}
          padding={"none"}
          align={alignPopover}
          distance={"none"}
          type={"primePrimary"}
        >
          <Box borderRadius={2}>
            <PrimeHooverBannerContainer
              pageCategoryName={trackingCategory}
              isPrimeLoggedUser={userLoggedInfo}
              isOpen={showBanner}
            />
          </Box>
        </Popover>
      </Flex>
    </Box>
  ) : (
    <></>
  );
};

export default HeaderPrimeButtonContainer;
